import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React from 'react';
import type {
  ChatResolveEntityOption,
  EditableResolveDraftNote,
} from '../../models/admin/AdminChatResolveDraft';
import { orderAttachToOptions } from '../../utils/chatResolveAttachTo';
import { formatSuggestedInvestmentLabel } from './chatResolveDraftsDialogUtils';

export interface ChatResolveDraftNoteEditorProps {
  note: EditableResolveDraftNote;
  attachToOptions: ChatResolveEntityOption[];
  onSelectedChange: (draftId: string, selected: boolean) => void;
  onContentChange: (draftId: string, content: string) => void;
  onEntityChange: (draftId: string, option: ChatResolveEntityOption) => void;
}

const ChatResolveDraftNoteEditor: React.FC<ChatResolveDraftNoteEditorProps> = ({
  note,
  attachToOptions,
  onSelectedChange,
  onContentChange,
  onEntityChange,
}) => {
  const suggestedInvestment = formatSuggestedInvestmentLabel(note.modelLabel);

  return (
    <Box
      sx={{
        border: '1px solid #e8e8e8',
        borderRadius: 1,
        p: 1.5,
        mb: 1.5,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={note.selected}
            onChange={(event) => onSelectedChange(note.draftId, event.target.checked)}
          />
        }
        label="Include"
      />
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Note"
        value={note.content}
        onChange={(event) => onContentChange(note.draftId, event.target.value)}
        sx={{ mb: 1.5 }}
      />
      <FormControl fullWidth size="small">
        <InputLabel>Attach to</InputLabel>
        <Select
          label="Attach to"
          value={`${note.modelType}:${note.modelExternalId}`}
          onChange={(event) => {
            const [modelType, modelExternalId] = String(event.target.value).split(':');
            const option = attachToOptions.find(
              (item) => item.modelType === modelType && item.modelExternalId === modelExternalId,
            );
            if (option) onEntityChange(note.draftId, option);
          }}
        >
          {orderAttachToOptions(attachToOptions, note).map((option) => (
            <MenuItem
              key={`${option.modelType}:${option.modelExternalId}`}
              value={`${option.modelType}:${option.modelExternalId}`}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {note.modelType === 'INVESTOR' && suggestedInvestment && (
          <FormHelperText>{`Suggested investment: ${suggestedInvestment}`}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default ChatResolveDraftNoteEditor;
